import * as React from "react";
import {
  createStyles,
  Grid,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { API } from "aws-amplify";
import { LoadingSpinner } from "../../../../utils/LoadingSpinner";
import NotificationTemplateDropDown from "./NotificationTemplateDropDown";
import NotificationContext from "./NotificationContext";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface INotificationProps
  extends WithStyles<typeof styles>,
    RouteComponentProps {
  opt?: any;
}

interface INotificationState {
  notificationSent: boolean;
  notificationTemplates: any[];
  personId: string;
}

class NotificationSection extends React.Component<
  INotificationProps,
  INotificationState
> {
  private notificationTemplateDropDown: any;
  private notificationContext: any;

  constructor(props: INotificationProps) {
    super(props);
    this.state = {
      notificationSent: true,
      notificationTemplates: [],
      personId: "",
    };
    this.getNotificationTemplates = this.getNotificationTemplates.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  public render() {
    const { classes } = this.props;
    const buttonClass = classes.buttonWrapper;

    return (
      <Grid item xs={12}>
        <form onSubmit={this.handleSubmit}>
          <NotificationTemplateDropDown
            notificationTemplate={this.state.notificationTemplates}
            ref={(ref) => (this.notificationTemplateDropDown = ref)}
          />
          <br />
          <h5> Please enter person id: </h5>
          <input
            name="personId"
            style={{ width: 350 }}
            type="text"
            onChange={this.handleChange}
            placeholder="i.e. amzn1.actor.person.oid.ABCDEFGH123456"
          />
          <br />
          <br />
          <h5> Default values for the context. Please feel free to change: </h5>
          <NotificationContext
            ref={(ref) => (this.notificationContext = ref)}
          />
          <br />
          <input
            type="submit"
            value="Send Notification"
            className={buttonClass}
          />
        </form>
        {!this.state.notificationSent && <LoadingSpinner />}
      </Grid>
    );
  }

  public componentDidMount() {
    this.getNotificationTemplates();
  }

  private getNotificationTemplates() {
    const apiName = "ApaqPortalAPI";
    const path = "/notification/get-notification-templates";

    API.get(apiName, path, {})
      .then((value: any) => {
        const result = [];
        for (const entry of value.notificationTemplates) {
          result.push(entry.templateId);
        }

        this.setState({ notificationTemplates: result });
      })
      .catch((error) => {
        console.error(error);
        alert("Exception occurred when getting notification templates.");
      });
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.personId) {
      alert("Please enter the person id");
      formIsValid = false;
    } else if (
      !this.state.personId.match(
        "^amzn[1-9]+[0-9]*.([A-Za-z0-9]+.)+A[A-Z0-9]*$"
      )
    ) {
      alert("Please enter the valid personId.");
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleSubmit(event: React.ChangeEvent<HTMLFormElement>) {
    event.preventDefault();

    if (this.handleValidation()) {
      this.setState({ notificationSent: false });

      const apiName = "ApaqPortalAPI";
      const path = "/notification/send-notification";
      const config = {
        body: {
          context: this.notificationContext.getState().value,
          personId: this.state.personId,
          templateId: this.notificationTemplateDropDown.getState().selectValue,
        },
        headers: {},
      };

      API.post(apiName, path, config)
        .then((response) => {
          console.log(response);
          this.setState({ notificationSent: true });
          alert("Notification has been sent.");
        })
        .catch((error) => {
          console.log(error);
          this.setState({ notificationSent: true });
          alert("Exception occurred when sending a notification.");
        });

      this.setState({ notificationSent: false });
    }
  }

  private handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ personId: event.target.value });
  }
}

export default withStyles(styles)(NotificationSection);
